import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { cachedBrand, fetchBrand } from '@/lib/appBrand';

/**
 * Start der installierten App (PWA).
 * Standard: die Startseite. Ist in den Einstellungen "Modul-Übersicht"
 * gewählt und der Nutzer eingeloggt, springt die App direkt in die Übersicht.
 * Greift nur beim ersten Öffnen der App und nie im normalen Browser-Tab.
 */
export const AppStartRedirect = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;

    const isStandalone = window.matchMedia('(display-mode: standalone)').matches
      || window.navigator.standalone === true
      || document.referrer.includes('android-app://');
    if (!isStandalone) return;
    if (location.pathname !== '/') return;
    if (!localStorage.getItem('token')) return;

    const jump = (brand) => {
      if (brand && brand.start_mode === 'dashboard') navigate('/uebersicht', { replace: true });
    };

    const cached = cachedBrand();
    if (cached) jump(cached);
    else fetchBrand().then(jump).catch(() => {});
  }, [location.pathname, navigate]);

  return null;
};

export default AppStartRedirect;
